module.exports = __webpack_public_path__ + "static/assets/2352f743e6b883d53e0b09b84ddea79b.mp3";